<div
  class="flex h-full flex-col justify-center px-[60px] py-[20px] lg:flex-row lg:p-[165px] lg:screen-max-size">
  <div class="flex flex-col items-center lg:my-auto">
    <rd-shared-icon
      class="icon-not-found h-[57px] w-[59px] lg:h-[120px] lg:w-[120px]"
      [iconSymbol]="'icon-not-found'"
      [iconTheme]="'error'"></rd-shared-icon>
  </div>
  <div
    class="text-content ml-0 flex flex-col justify-center lg:ml-[55px] lg:w-1/2">
    <h1
      class="page-not-found-header mt-[18px] mb-0 text-center text-[#002f6b] typo-emphasis-1-desktop lg:text-left lg:typo-heading-2-desktop">
      {{ 'core.page_not_found.header' | translate }}
    </h1>
    <p
      class="page-not-found-description my-[12px] text-center text-[#002f6b] typo-emphasis-5-desktop lg:mt-[10px] lg:mb-[20px] lg:ml-[0] lg:mr-[38px] lg:text-left">
      {{ 'core.page_not_found.description' | translate }}
    </p>
  </div>
</div>
